// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint, cartPageTemplateStyles } from "@steiner/App/Components/Cart/CartPageTemplate";
import { DivWrapper } from "@steiner/XDL/constants";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartPageTemplateStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 317px);
        grid-column-gap: 22px;

        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
            grid-column-gap: 20px;
        }

        @media print {
            display: block;
        }
    `,
};

cartPageTemplateStyles.headerSection = {
    css: css`
        grid-row: 1/2;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1/3;
        }

        @media print {
            width: 100%;
        }
    `,
};

cartPageTemplateStyles.titleSection = {
    css: css`
        width: 100%;
    `,
};

cartPageTemplateStyles.actionsSection = {
    css: css`
        width: 100%;
        padding-bottom: 12px;

        ${xScreen("lte", "md")} {
            border-bottom: 1px solid ${color("common.border")};
        }

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            margin-top: 32px;
            padding-bottom: 16px;

            @media print {
                margin-top: 0;
            }
        }
    `,
};

cartPageTemplateStyles.mainSection = {
    css: css`
        grid-row: 2/3;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            ${({ isEmptyCart }: any) => {
                if (isEmptyCart) {
                    return css`
                        grid-row: 2/3;
                    `;
                }
                return css`
                    grid-row: 3/3;
                `;
            }}
            grid-column: 1/3;

            width: 100%;
            padding: 0;
            margin-top: 0;
            margin-bottom: 0;
        }

        @media print {
            width: 100%;
        }
    `,
};

cartPageTemplateStyles.totalSection = {
    css: css`
        grid-row: 1/4;
        & > div.xng-sticky > ${DivWrapper} > div:not(:last-child) {
            margin-bottom: 20px;
        }

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            ${({ isEmptyCart }: any) => {
                if (isEmptyCart) {
                    return css`
                        grid-row: 3/3;
                    `;
                }
                return css`
                    grid-row: 2/3;
                `;
            }}
            grid-column: 1/3;

            width: 100%;
            display: flex;
            justify-content: center;
            & > div.xng-sticky > ${DivWrapper} {
                height: auto;
            }
        }

        ${xScreen("lte", "xs")} {
            & > div.xng-sticky {
                max-width: 100%;
            }
        }

        @media print {
            & > div.xng-sticky {
                position: static;
            }
        }
    `,
};

cartPageTemplateStyles.cartApproverMessage = {
    css: css`
        margin-bottom: 12px;
        &:has(div[class^="Wrapper"]:empty) {
            display: none;
        }
    `,
};

cartPageTemplateStyles.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
